/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BidManagementEditOrderResponse } from './BidManagementEditOrderResponse';

export type BidManagementEditOrderResponseApiRespoonse = {
    data?: BidManagementEditOrderResponse;
    status?: BidManagementEditOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace BidManagementEditOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

